<template>
  <a v-if="!accountId" class="my-5 block" :href="url">
    <img src="@/assets/images/stripe_connect.png" width="200px" />
  </a>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  form: { type: Object, default: () => ({}) },
  providerKey: { type: String, required: true },
  url: { type: String, default: "" },
});

const accountId = computed(() => props.form?.[props.providerKey]?.account_id);
</script>
